<app-breadcrumb [master]="'Rejestracje'" [parentName]="'KRK'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-krk-details-view *ngIf="!modify" [krk]="krk" (modifyClicked)="modify = true"></app-krk-details-view>
    <app-krk-add *ngIf="modify" [krk]="krk" (closeModification)="modify = false; loadKrk()"></app-krk-add>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-document-list [excludeColumns]="['deviceProtocolDate']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [krk]="krk"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
